export const agentMessageCopySuccess = 'Copied the client reach-out message to your clipboard.';
export const agentMessageCopyValue = 'Copy client reach-out text message';
